<template>
    <button
        v-tippy="t('editorToggleHeader1')"
        :class="[
            buttonState(
                editor.can().toggleHeading({ level: 1 }),
                editor.isActive('heading', { level: 1 }),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleHeading({ level: 1 })"
        @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
    >
        <MdiFormatHeader1 class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatHeader1 from 'materialdesignicons-vue3/icons/MdiFormatHeader1.js';

    defineExpose({
        name: 'FormatHeader1Button',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
